const KEY_COLORS: Record<string, string> = {
  '1A': '#3ed9b4',
  '1B': '#56f0c8',
  '2A': '#59ee9b',
  '2B': '#6ee8ee',
  '3A': '#7ae85a',
  '3B': '#8dee6e',
  '4A': '#b6ee4c',
  '4B': '#c4ee5f',
  '5A': '#e4ee58',
  '5B': '#eee86e',
  '6A': '#eec062',
  '6B': '#eed56e',
  '7A': '#ee9a62',
  '7B': '#eeaa5a',
  '8A': '#ee7b7b',
  '8B': '#ee8a6e',
  '9A': '#ee7bb4',
  '9B': '#ee7bce',
  '10A': '#c47bee',
  '10B': '#b07bee',
  '11A': '#7b9aee',
  '11B': '#7bb4ee',
  '12A': '#56d0f0',
  '12B': '#56e8ee',
};

const normalizeKey = (camelotKey: string | undefined): string =>
  (camelotKey || '').toUpperCase().replace(/\s/g, '');

const hexToRgba = (hex: string, alpha: number): string => {
  const raw = hex.replace('#', '');
  const r = parseInt(raw.slice(0, 2), 16);
  const g = parseInt(raw.slice(2, 4), 16);
  const b = parseInt(raw.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const camelotKeyColor = (camelotKey: string | undefined): string => {
  if (!camelotKey) return 'rgba(255,255,255,0.5)';
  return KEY_COLORS[normalizeKey(camelotKey)] || 'rgba(255,255,255,0.5)';
};

export const camelotKeyBackground = (
  camelotKey: string | undefined,
): string => {
  const color = camelotKeyColor(camelotKey);
  if (!color.startsWith('#')) return 'rgba(255,255,255,0.08)';
  return hexToRgba(color, 0.16);
};
